export default __webpack_public_path__ + "e8068c51f92b8d3cd47d7239ef3c30e8.png";